/* eslint-disable no-global-assign */
// @ts-nocheck

import Log from './logging'

const log = new Log()

log.enable()
log.name = 'Patch'

const keep_obsolete = true
let implement
if (keep_obsolete) {
  implement = function(methods) {
    for (const [key, value] of Object.entries(methods)) {
      if (typeof this.prototype === 'undefined') {
        if (typeof this[key] !== 'undefined') {
          this[key] = value
        }
      } else {
        if (typeof this.prototype[key] !== 'function') {
          this.prototype[key] = value
        }
        // console.log(`implement: ${key}`, typeof this.prototype, typeof this.prototype[key])
      }
    }
  }

  // obsolete
  if (typeof HTMLElement !== 'function') {
    const _HTMLElement = function() {}
    _HTMLElement.prototype = HTMLElement.prototype
    HTMLElement = _HTMLElement
  }

  if (typeof Element !== 'function') {
    const _Element = function() {}
    _Element.prototype = Element.prototype
    Element = _Element
  }

  if (typeof Document !== 'function') {
    const _Document = function() {}
    _Document.prototype = Document.prototype
    Document = _Document
  }

  if (typeof Window !== 'function') {
    const _Window = function() {}
    _Window.prototype = Window.prototype
    Window = _Window
  }

  if (Function.prototype.implement == null) {
    Function.prototype.implement = implement
  }
} else {
  implement = function(methods) {
    for (const [key, value] of Object.entries(methods)) {
      if (typeof this.prototype[key] !== 'function') {
        this.prototype[key] = value
      }
    }
  }
}

// legacy interfaces
const removeClass = function(cls) {
  this.classList.remove(cls)
}

const hasClass = function(cls) {
  return this.classList.contains(cls)
}

const addClass = function(cls) {
  this.classList.add(cls)
}

const getElement = function(tag) {
  return [...this.querySelectorAll(tag)][0]
}

const getElements = function(tag) {
  return [...this.querySelectorAll(tag)]
}

const getParent = function() {
  return this.parentElement
}

const getParents = function() {
  const list = []
  let c = this
  while (c.parentElement != undefined) {
    list.push(c.parentElement)
    c = c.parentElement
  }
  return list
}

const addEvent = function(type, handler) {
  if (['touchstart', 'touchend', 'touchmove'].contains(type)) {
    this.addEventListener(type, handler, {
      passive: true
    })
  } else {
    this.addEventListener(type, handler, false)
  }
}

const getStyles = function(styles) {
  return {
    ...styles
  }
}

const setStyles = function(styles) {
  Object.assign(this.style, styles)
}

const getStyle = function(attribute) {
  return this.style[attribute]
}

const setStyle = function(attribute, value) {
  this.style[attribute] = value
}

const getDimensions = function() {
  return {
    x: this.offsetWidth,
    y: this.offsetHeight
  }
}

const contains = function(elem) {
  return this.indexOf(elem) > -1
  // for backwards compatability
  // return this.includes(elem);
}

const swapDelete = function(item) {
  const index = this.indexOf(item)
  if (index > -1) {
    this[index] = this[this.length - 1]
    this.pop()
  }
}

const remove = function(elem) {
  const index = this.indexOf(elem)
  if (index > -1) {
    this.splice(index)
  }
}

const first = function() {
  return this[0]
}

const replace = function(elem, newelem) {
  const index = this.indexOf(elem)
  if (index > -1) {
    this[index] = newelem
  }
}

// const isInViewport1 = function() {
//   const bounds = this.getBoundingClientRect();
//   return bounds.top < window.innerHeight && bounds.bottom > 0;
// }

const wraps = function(elem) {
  const parent = elem.parentElement
  parent.replaceChild(this, elem)

  this.appendChild(elem)
}

const insert = function(elem) {
  // const parent = elem.parentElement;
  console.warn('children:', elem.children);
  [...elem.children].forEach(c => this.appendChild(c))
  // parent.replaceChild(this, elem);

  elem.appendChild(this)
}

const dispose = function() {
  this.parentNode.removeChild(this)
}

const capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

Element.implement({
  addClass,
  removeClass,
  hasClass,
  setStyle,
  setStyles,
  getStyle,
  getStyles,
  getElement,
  getElements,
  getParent,
  getParents,
  addEvent,
  getDimensions,
  wraps,
  insert,
  dispose
  // delete: delete,
  // isInViewport: isInViewport
})

Document.implement({
  getElement,
  addEvent
})

Window.implement({
  addEvent
})

Array.implement({
  contains,
  swapDelete,
  remove,
  replace,
  first
})

String.implement({
  capitalize
})

// adapted from MooTools
const delay = function(delay, bind, args) {
  return setTimeout(this.pass(args === null ? [] : args, bind), delay)
}

Function.implement({
  delay
  // bind: bind
})